export default __webpack_public_path__ + "static/empty-53e4954b72c963c87c010b6de4d4c3aa.png";